import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isAuthenticated()) {
      console.log('not authenticated');

      this.router.navigate(['/', 'session', 'log-in'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    // calculate permissions
    const leaf = this.getLeafRoute(route);

    if (
      leaf.data.roles &&
      !leaf.data.roles.includes(this.authService.getUserRole())
    ) {
      console.log('not authorized');
      console.log(leaf.data.roles, this.authService.getUserRole());

      this.router.navigate(['/']);
      return false;
    }

    const adminType = await this.authService.getAdminType();
    if (
      leaf.data.adminTypes &&
      adminType &&
      !leaf.data.adminTypes.includes(adminType)
    ) {
      console.log('not authorized');

      this.router.navigate(['/', 'admin']);
    }

    const adminTeam = this.authService.getAdminTeam();
    if (
      leaf.data.adminTeams &&
      adminTeam &&
      !leaf.data.adminTeams.includes(adminTeam)
    ) {
      console.log('not authorized');

      this.router.navigate(['/', 'admin']);
    }

    return true;
  }

  getLeafRoute(root: ActivatedRouteSnapshot) {
    if (root.children?.length > 0) {
      return this.getLeafRoute(root.children[0]);
    }

    return root;
  }
}
